<section class="tasks-container">
  <div class="tasks-heading">
    <i class="bx bx-check-circle heading-icon"></i>
    <h1>Tasks</h1>
  </div>
  <div class="delete-section d-flex align-items-center gap-2" *ngIf="selectedTasks.length > 0"
    [ngClass]="{ 'disabled-dropdown': privilege === 'VIEW' }">
    <span class="badge d-flex align-items-center gap-1" style="border-radius: 4px;">
      {{selectedTasks.length}}task selected
      <i class="bx bx-trash" style="cursor: pointer; font-size: 1rem; color: red; margin-left: 15px;"
        ngbTooltip="delete" (click)="deleteSelectedTasks()" ngbTooltip="Delete selected tasks"></i>
    </span>
  </div>
  <div class="tasks-nav d-flex justify-content-between align-items-center">
    <div class="tabs d-flex align-items-center">
      <button class="tab">
        <i class="bx bx-task"></i> Tasks
      </button>
    </div>
    <div class="actions d-flex align-items-center gap-2">
      <!-- Filter -->
      <div ngbDropdown class="d-inline-block" #filterDropdown="ngbDropdown" autoClose="outside">
        <div class="filter-button-wrapper">
          <span class="filter-icon">
            <i class="bx bx-filter" style="font-size: large;" (click)="toggleDropdown(filterDropdown)"
              ngbTooltip="Filter"></i>
          </span>
        </div>
        <div ngbDropdownMenu aria-labelledby="filterDropdown" class="filter-dropdown-menu"
          [hidden]="!isFilterDropdownOpen">
          <div class="p-3">
            <div class="mb-2">
              <label for="status-filter"><i class="bx bx-list-check mr-1"></i>Status</label>
              <ng-select id="status-filter" placeholder="Select Status" [(ngModel)]="selectedStatus" class="ng-filter"
                [clearable]="true" [searchable]="false">
                <ng-option *ngFor="let status of statuses" [value]="status">
                  {{ getTaskStatus(status) }}
                </ng-option>
              </ng-select>
            </div>
            <div class="mb-2">
              <label for="assignee-filter"><i class="bx bx-user mr-1"></i>Assignee</label>
              <ng-select id="assignee-filter" placeholder="Select Assignee" [(ngModel)]="selectedAssigneeId"
                class="ng-filter" [clearable]="true" [searchable]="true">
                <ng-option *ngFor="let employee of employees" [value]="employee.employeeId">
                  {{ employee.employeeName }}
                </ng-option>
              </ng-select>
            </div>
            <div class="mb-2">
              <label for="priority-filter"><i class="bx bx-flag mr-1"></i>Priority</label>
              <ng-select id="priority-filter" placeholder="Select Priority" [(ngModel)]="selectedPriority"
                class="ng-filter" [clearable]="true" [searchable]="false">
                <ng-option *ngFor="let priority of priorities" [value]="priority">
                  {{ priority }}
                </ng-option>
              </ng-select>
            </div>
            <div class="mb-2">
              <label for="deadline-date"><i class="bx bx-calendar mr-1"></i>Deadline</label>
              <input type="date" id="deadline-date" [(ngModel)]="deadlineDate" class="form-control" #dueDateRef
                (click)="toggleDueDate(task.value, dueDateRef)" (ngModelChange)="deadlineDateRef?.blur()"
                #deadlineDateRef />
            </div>
            <button type="button" class="btn btn-secondary w-100" (click)="applyFilters(filterDropdown)">
              Apply
            </button>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-secondary" style="line-height: 1;" [disabled]="privilege === 'VIEW'"
        (click)="openSidePopup(false, null, task.value)">
        <i class="ri-add-line me-1"></i> Add
      </button>
    </div>
  </div>
  <div class="active-filters" *ngIf="hasActiveFilters()">
    <div class="filter-tags">
      <div class="filter-tag" *ngIf="selectedStatus">
        <i class="bx bx-list-check filter-tag-icon"></i>
        <span class="filter-label">Status:</span>
        <span class="filter-values">{{ getStatusDisplayText() }}</span>
        <i class="bx bx-x filter-remove" (click)="clearFilter('status')" title="Remove filter"></i>
      </div>
      <div class="filter-tag" *ngIf="selectedAssigneeId">
        <i class="bx bx-user filter-tag-icon"></i>
        <span class="filter-label">Assigned To:</span>
        <span class="filter-values">{{ getAssigneeDisplayText() }}</span>
        <i class="bx bx-x filter-remove" (click)="clearFilter('assignee')" title="Remove filter"></i>
      </div>
      <div class="filter-tag" *ngIf="selectedPriority">
        <i class="bx bx-flag filter-tag-icon"></i>
        <span class="filter-label">Priority:</span>
        <span class="filter-values">{{ selectedPriority }}</span>
        <i class="bx bx-x filter-remove" (click)="clearFilter('priority')" title="Remove filter"></i>
      </div>
      <div class="filter-tag" *ngIf="deadlineDate">
        <i class="bx bx-calendar filter-tag-icon"></i>
        <span class="filter-label">Deadline:</span>
        <span class="filter-values">{{ deadlineDate | date:'MMM dd, yyyy' }}</span>
        <i class="bx bx-x filter-remove" (click)="clearFilter('deadline')" title="Remove filter"></i>
      </div>
    </div>
  </div>
  <div class="tasks-table">
    <div class="table-header">
      <div class="checkbox-column"  [ngClass]="{ 'disabled-dropdown': privilege === 'VIEW' }">
        <input type="checkbox" [checked]="isAllTasksSelected" (click)="toggleAllTasks($event)">
      </div>
      <div class="id-column"><i class="bx bx-hash"></i>ID</div>
      <div class="name-column"><i class="bx bx-file-blank"></i> Title</div>
      <div class="status-column"><i class="bx bx-loader-circle"></i>
        Status</div>
      <div class="assignee-column"><i class="bx bx-user-check"></i>
        Assignee</div>
      <div class="priority-column"><i class="bx bx-flag"></i> Priority</div>
      <div class="date-column" (click)="toggleDatePicker()"><i class="bx bx-calendar"></i> Due Date</div>
      <div class="date-column"><i class="bx bx-calendar"></i> Start Date</div>
      <div class="date-column"><i class="bx bx-calendar"></i> Completed Date</div>
      <div class="estimated-hours-column"><i class="bx bx-task"></i> Exp
        Hrs</div>
      <div class="completed-hours-column"><i class="bx bx-task"></i> Completed Time
      </div>
      <div class="milestone-column"><i class="bx bx-calendar"></i>
        Milestone</div>
      <div class="attachments-column"><i class="bx bx-task"></i>
        Attachments</div>
      <div class="notes-column"><i class="ri-article-line"></i>
        Notes</div>
    </div>
    <div class="table-body" #tableBody (scroll)="onTableScroll($event)">
      <form [formGroup]="task"  [ngClass]="{ 'disabled-dropdown': privilege === 'VIEW' }">
        <ng-container formArrayName="tasks" *ngFor="let task of tasks.controls; let i = index">
          <div class="table-row" [formGroupName]="i"
            [ngClass]="{'selected': task.id && selectedTasks.includes(task.id)}">
            <div class="checkbox-column">
              <input type="checkbox" formControlName="selected" tabindex="-1"
                (change)="toggleTaskSelection(task?.value?.id)" />
            </div>
            <div class="id-column">{{ task?.value?.code }}</div>
            <!-- Name -->
            <div class="name-column">
              <i class="bx" [ngClass]="{'bx-chevron-right': !task.isExpanded, 'bx-chevron-down': task.isExpanded}"
                (click)="toggleExpand(task)"></i>
              <div class="name-input-container" (mouseenter)="hoveredTaskIndex = i"
                (mouseleave)="hoveredTaskIndex = null">
                <textarea rows="1" #taskTitle (input)="resizeTextArea(taskTitle)" formControlName="title"
                  placeholder="Enter task title" class="name-input" (focus)="focusedTaskIndex = i"
                  (blur)="focusedTaskIndex = null; upsertTask(task)">
              </textarea>
                <button class="open-button" *ngIf="hoveredTaskIndex === i && focusedTaskIndex !== i"
                  (click)="openSidePopup(false, task?.value?.id, task.value)" ngbTooltip="Open in side peek"
                  placement="top" container="body">
                  OPEN
                </button>
              </div>
            </div>
            <!-- Status -->
            <div class="status-column" tabindex="0" (keydown)="handleKeyDown($event, task, 'status')">
              <div class="status-dropdown">
                <div class="status-display" [id]="'trigger-' + task.value.id"
                  (click)="toggleStatusDropdown(task.value)">
                  <span class="status-badge" [ngClass]="{
                'status-not-started': task.value.status === 'NOT_STARTED' || !task.value?.status,
                'status-in-progress': task.value.status === 'IN_PROGRESS',
                'status-completed': task.value.status === 'COMPLETED',
                'status-on-hold': task.value.status === 'HOLD',
                'status-re-assigned': task.value.status === 'REASSIGNED'
                  }">
                    <i
                      [class]="'bx ' + (task.value.status === 'NOT_STARTED' ? 'bx-pause-circle' : task.value.status === 'IN_PROGRESS' ? 'bx-time' : task.value.status === 'COMPLETED' ? 'bx-check-circle' : task.value.status === 'REASSIGNED' ? 'bx-refresh' : 'bx-stop-circle')"></i>
                    {{ getTaskStatus(task?.value?.status) }}
                  </span>
                </div>
                <div class="dropdown-menu" *ngIf="task.value.showStatusDropdown"
                  [ngClass]="{'dropdown-top': dropdownDirections[task.value.id] === 'top'}" (document:click)="
              $event.target.closest('#trigger-' + task.value.id) ? null : closeAllDropdowns(task.value)">
                  <div class="dropdown-item" *ngFor="let status of statuses; let s=index" [ngStyle]="{
       'pointer-events': status === 'HOLD' && privilege !== 'DELETE' ? 'none' : 'auto',
       'opacity': status === 'HOLD' && privilege !== 'DELETE' ? 0.10 : 1,
       'cursor': status === 'HOLD' && privilege !== 'DELETE' ? 'not-allowed' : 'pointer'
     }" (click)="status === 'HOLD' && privilege !== 'DELETE' ? null : setStatus(task, status)"
                    [class.active]="s === searchIndex">
                    <span class="status-badge" [ngClass]="{
                  'status-not-started': status === 'NOT_STARTED',
                  'status-in-progress': status === 'IN_PROGRESS',
                  'status-completed': status === 'COMPLETED',
                  'status-on-hold': status === 'HOLD',
                  'status-re-assigned': status === 'REASSIGNED'
                      }">
                      <i
                        [class]="'bx ' + (status === 'NOT_STARTED' ? 'bx-pause-circle' : status === 'IN_PROGRESS' ? 'bx-time' : status === 'COMPLETED' ? 'bx-check-circle' : status === 'REASSIGNED' ? 'bx-refresh' : 'bx-stop-circle')"></i>
                      {{ getTaskStatus(status) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Assignee -->
            <div class="assignee-column" tabindex="0" (keydown)="handleKeyDown($event, task, 'assignee')">
              <div class="assignee-dropdown">
                <div class="assignee-display" [id]="'trigger-' + task.value.id"
                  (click)="toggleAssigneeDropdown(task.value)">
                  <div *ngIf="task?.value?.assignedToId" class="selected-assignee">
                    <ng-container
                      *ngIf="task?.value?.assignedToAvatar && (task?.value?.assignedToAvatar.startsWith('data:image/') || task?.value?.assignedToAvatar.startsWith('http')); else showInitialSelected">
                      <img class="assignee-avatar" [src]="task?.value?.assignedToAvatar" alt="avatar" />
                    </ng-container>
                    <ng-template #showInitialSelected>
                      <div class="assignee-avatar capitalize">{{ task?.value?.assignedToName?.charAt(0) || '' }}</div>
                    </ng-template>
                    {{ task?.value?.assignedToName }}
                  </div>
                  <div *ngIf="!task?.value?.assignedToId" class="assignee-placeholder">Select Assignee...</div>
                </div>

                <div class="dropdown-menu" *ngIf="task.value.showAssigneeDropdown"
                  [ngClass]="{'dropdown-top': dropdownDirections[task.value.id] === 'top'}" (document:click)="
      $event.target.closest('#trigger-' + task.value.id) ? null : closeAllDropdowns(task.value)">
                  <div class="dropdown-search">
                    <i class="bx bx-search"></i>
                    <input appAutofocus type="text" placeholder="Type to search..."
                      (input)="searchKeyword=$event.target.value" (keydown)="handleKeyDown($event, task, 'assignee')">
                  </div>
                  <div class="dropdown-list">
                    <ng-container
                      *ngIf="(employees | search : 'employeeName' : searchKeyword)?.length > 0; else noEmployeesFound">
                      <div *ngFor="let employee of employees | search : 'employeeName' : searchKeyword; let a = index"
                        class="dropdown-item" [class.active]="a === searchIndex" (click)="setAssignee(task, employee)">
                        <ng-container
                          *ngIf="employee.avatar && (employee.avatar.startsWith('data:image/') || employee.avatar.startsWith('http')); else showInitialDropdown">
                          <img class="assignee-avatar" [src]="employee.avatar" alt="avatar" />
                        </ng-container>
                        <ng-template #showInitialDropdown>
                          <div class="assignee-avatar capitalize">{{ employee.employeeName?.charAt(0) || '' }}</div>
                        </ng-template>
                        {{ employee.employeeName }}
                      </div>
                    </ng-container>
                    <ng-template #noEmployeesFound>
                      <div class="no-results">No matches found</div>
                    </ng-template>
                  </div>
                  <div class="dropdown-footer" (click)="setAssignee(task, null)">
                    <i class="bx bx-x"></i>Clear
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="assignee-column" tabindex="0" (keydown)="handleKeyDown($event, task, 'assignee')">
              <div class="assignee-dropdown">
                <div class="assignee-display" [id]="'trigger-' + task.value.id"
                  (click)="toggleAssigneeDropdown(task.value)">
                  <div *ngIf="task?.value?.assignedToId" class="selected-assignee">
                    <div class="assignee-avatar capitalize">{{ task?.value?.assignedToName.charAt(0) }}</div>
                    {{ task?.value?.assignedToName }}
                  </div>
                  <div *ngIf="!task?.value?.assignedToName" class="assignee-placeholder">Select Assignee...</div>
                </div>
                <div class="dropdown-menu" *ngIf="task.value.showAssigneeDropdown"
                  [ngClass]="{'dropdown-top': dropdownDirections[task.value.id] === 'top'}" (document:click)="
              $event.target.closest('#trigger-' + task.value.id) ? null : closeAllDropdowns(task.value)">
                  <div class="dropdown-search">
                    <i class="bx bx-search"></i>
                    <input appAutofocus type="text" placeholder="Type to search..."
                      (input)="searchKeyword=$event.target.value" (keydown)="handleKeyDown($event, task, 'assignee')">
                  </div>
                  <div class="dropdown-list">
                    <div
                      *ngIf="(employees | search : 'employeeName' : searchKeyword)?.length > 0; else noEmployeesFound">
                      <div *ngFor="let employee of employees | search : 'employeeName' : searchKeyword; let a = index"
                        class="dropdown-item" [class.active]="a === searchIndex" (click)="setAssignee(task, employee)">
                        <div class="assignee-avatar">{{employee.avatar|| employee.employeeName.charAt(0) }}</div>
                        {{ employee.employeeName }}
                      </div>
                    </div>
                    <ng-template #noEmployeesFound>
                      <div class="no-results">No matches found</div>
                    </ng-template>
                  </div>
                  <div class="dropdown-footer" (click)="setAssignee(task, null)">
                    <i class="bx bx-x"></i>Clear
                  </div>
                </div>
              </div>
            </div> -->
            <!-- Priority -->
            <div class="priority-column" tabindex="0" (keydown)="handleKeyDown($event, task, 'priority')">
              <div class="priority-dropdown">
                <div class="priority-display" [id]="'trigger-' + task.value.id"
                  (click)="togglePriorityDropdown(task.value)">
                  <span class="priority-badge" [ngClass]="{
                  'priority-low': task.value.priority === 'LOW',
                  'priority-medium': task.value.priority === 'MID',
                  'priority-high': task.value.priority === 'HIGH'
                }">
                    <i class="bx bxs-flag-alt"></i>
                    {{ task.value.priority || 'LOW' }}
                  </span>
                </div>
                <div class="dropdown-menu" *ngIf="task.value.showPriorityDropdown"
                  [ngClass]="{'dropdown-top': dropdownDirections[task.value.id] === 'top'}" (document:click)="
              $event.target.closest('#trigger-' + task.value.id) ? null : closeAllDropdowns(task.value)">
                  <div class="dropdown-item" *ngFor="let priority of priorities; let s=index"
                    (click)="setPriority(task, priority)" [class.active]="s === searchIndex">
                    <span class="priority-badge" [ngClass]="{
                      'priority-low': priority === 'LOW',
                      'priority-medium': priority === 'MID',
                      'priority-high': priority === 'HIGH'
                    }">
                      <i class="bx bxs-flag-alt"></i>
                      {{ priority }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Due Date -->
            <div class="date-column" tabindex="0" (click)="toggleDueDate(task.value, dueDateRef)"
              (keydown)="handleKeyDown($event, task, 'dueDate')" (document:click)="
              $event.target.closest('#trigger-' + task.value.id) ? null : closeAllDropdowns(task.value)">
              <input [hidden]="!task.value.showDueDate" type="date" #dueDateRef (change)="upsertTask(task)"
                formControlName="deadLine" class="date-input">
              <span style="margin-left: 12px;" *ngIf="!task?.value?.showDueDate">{{ task.value.deadLine ?
                (task.value.deadLine | date:'dd MMM,
                yyyy') : '' }}</span>
            </div>
            <!-- Start Date -->
            <div class="date-column" tabindex="0">
              <input [hidden]="!task.value.showStartDate" type="date" #estimatedTime readonly
                formControlName="startDate" class="date-input">
              <span *ngIf="!task.value.showStartDate" style="margin-left: 20px;">{{ task.value.startDate | date:'dd MMM,
                yyyy' }}</span>
            </div>
            <!-- Completed Date -->
            <div class="date-column" tabindex="0">
              <input [hidden]="!task.value.showCompletedDate" type="date" readonly formControlName="endDate"
                class="date-input">
              <span *ngIf="!task.value.showCompletedDate" style="margin-left: 26px;">{{ task.value.endDate |
                date:'dd MMM, yyyy'}}</span>
            </div>
            <!-- Expected Hours -->
            <div class="estimated-hours-column" tabindex="0">
              <input type="number" class="form-control" style="width: 68%;" formControlName="estimatedHour"
                (blur)="upsertTask(task)" (keydown)="onFieldKeyDown($event, task)" placeholder="" />
            </div>
            <!-- Completed Time -->
            <div class=" start-time-column" tabindex="0">
              <i class="ri-timer-line" style="display: none;"></i>
              <span *ngIf="task.value.completedHour !== undefined"
                [ngbTooltip]="getCompletedHourTooltip(task.value.completedHour)">
                {{ task.value.completedHour}}
              </span>
            </div>
            <!-- Milestone -->
            <div class="milestone-columns" tabindex="0" (keydown)="handleKeyDown($event, task, 'milestone')">
              <div class="assignee-dropdown">
                <div class="assignee-display" [id]="'trigger-' + task.value.id"
                  (click)="toggleMilestoneDropdown(task.value)">
                  <div *ngIf="task?.value?.milestoneId" class="selected-assignee" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%;">
                    {{ task?.value?.milestoneName }}
                  </div>
                  <div *ngIf="!task?.value?.milestoneName" class="assignee-placeholder">Select...</div>
                  <i class="bx bx-chevron-down"></i>
                </div>
                <div class="dropdown-menu" *ngIf="task.value.showMilestoneDropdown"
                  [ngClass]="{'dropdown-top': dropdownDirections[task.value.id] === 'top'}" (document:click)="
              $event.target.closest('#trigger-' + task.value.id) ? null : closeAllDropdowns(task.value)">
                  <div class="dropdown-search">
                    <i class="bx bx-search"></i>
                    <input appAutofocus type="text" placeholder="Search milestone..."
                      (input)="searchKeyword=$event.target.value" (keydown)="handleKeyDown($event, task, 'milestone')">
                  </div>
                  <div class="dropdown-list">
                    <div *ngIf="(milestones | search : 'title' : searchKeyword)?.length > 0; else noMilestonesFound">
                      <div *ngFor="let milestone of milestones | search : 'title' : searchKeyword; let m = index"
                        class="dropdown-item" (click)="setMilestone(task, milestone)"
                        [class.active]="m === searchIndex">
                        <div class="assignee-avatar">{{ milestone.title.charAt(0) }}</div>
                        {{ milestone.title }}
                      </div>
                    </div>
                    <ng-template #noMilestonesFound>
                      <div class="no-results">No matches found</div>
                    </ng-template>
                  </div>
                  <div class="dropdown-footer" (click)="setMilestone(task, null)">
                    <i class="bx bx-x"></i>Clear
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="milestone-column" tabindex="0" (keydown.enter)="toggleMilestoneDropdown(task.value,search);">
              <div class="assignee-dropdown">
                <div class="assignee-display" (click)="toggleMilestoneDropdown(task.value,search);">
                  <div *ngIf="task?.value?.milestoneId" class="selected-assignee" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%;">
                    {{ task?.value?.milestoneName }}
                  </div>
                  <div *ngIf="!task?.value?.milestoneName" class="assignee-placeholder">Select...</div>
                  <i class="bx bx-chevron-down"></i>
                </div>
                <div class="dropdown-menu" *ngIf="task.value.showMilestoneDropdown">
                  <div class="dropdown-search">
                    <i class="bx bx-search"></i>
                    <input appAutofocus type="text" placeholder="Search milestone..." autofocus
                      (input)="searchKeyword=$event.target.value" (keydown)="handleKeyDown($event,task,'milestone')">
                  </div>
                  <div class="dropdown-list">
                    <div *ngIf="(milestones | search : 'title' : searchKeyword)?.length > 0; else noMilestonesFound">
                      <div *ngFor="let milestone of milestones | search : 'title' : searchKeyword; let m = index"
                        class="dropdown-item" (click)="setMilestone(task, milestone)"
                        [class.active]="m === searchIndex">
                        <div class="assignee-avatar">{{
                          milestone.title.charAt(0)
                          }}</div>
                        {{ milestone.title }}
                      </div>
                    </div>
                    <ng-template #noMilestonesFound>
                      <div class="no-results">No matches found</div>
                    </ng-template>
                  </div>
                  <div class="dropdown-footer" (click)="setMilestone(task,null)">
                    <i class="bx bx-x"></i>Clear
                  </div>
                </div>
              </div>
            </div> -->
            <!-- Attachments -->
            <div class="attachments-column" tabindex="0">
              <div class="file-picker">
                <div class="image-grid" formArrayName="taskAttachments">
                  <ng-container *ngFor="let attachment of task.get('taskAttachments').controls; let j = index">
                    <div *ngIf="attachment.value.fileUrl && attachment.value.fileUrl?.length > 15"
                      class="attachment-item" [formGroupName]="j">
                      <div class="image-wrapper">
                        <a [href]="attachment.value.fileUrl" download target="_blank">
                          <img [src]="getFilePreviewIcon(attachment.value.fileUrl)" alt="Uploaded Image"
                            class="uploaded-image" />
                        </a>
                      </div>
                    </div>
                  </ng-container>
                  <div class="icon-wrapper" (click)="fileInput.click()" ngbTooltip="Add attachment" placement="top"
                    container="body">
                    <i class="bx bx-paperclip attachment-add-icon"></i>
                  </div>
                </div>
                <input type="file" #fileInput
                  accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx,.mp4,.avi,.mov,.mkv" style="display: none"
                  (change)="onFileSelected($event, task.value, i)" />
              </div>
            </div>
            <!-- Notes -->
            <div class="notes-column">
              <textarea rows="1"  #taskTitle (input)="resizeTextArea(taskTitle)" (input)="resizeTextArea(taskNotes)" formControlName="desc"
                (blur)="upsertTask(task)" (keydown)="onFieldKeyDown($event, task)" placeholder="Enter notes..."
                class="notes-input"></textarea>
            </div>
          </div>

          <!-- <ng-container *ngIf="task.isExpanded">
          <div class="table-row sub-item"
            *ngFor="let subTask of subtasks | filterByTaskId:task.id; trackBy: trackBySubItemId"
            [ngClass]="{'selected': subTask.id && selectedTasks.includes(subTask.id)}">
            <div class="checkbox-column">
              <input type="checkbox"
                [checked]="subTask.id && selectedTasks.includes(subTask.id)"
                (change)="toggleTaskSelection(subTask.id)">
            </div>
            <div class="id-column">{{ subTask.id }}</div>
            <div class="name-column sub-item-name">
              <input *ngIf="!subTask.title || subTask.isEditing"
                [(ngModel)]="subTask.title"
                placeholder="Enter sub-task title" class="name-input"
                (blur)="saveSubTaskName(subTask)"
                (keyup.enter)="saveSubTaskName(subTask)">
              <span *ngIf="subTask.title && !subTask.isEditing"
                (click)="editSubTaskName(subTask)">{{ subTask.title
                }}</span>
            </div>
            <div class="status-column">
              <div class="status-dropdown">
                <div class="status-display"
                  (click)="toggleStatusDropdown(subTask)">
                  <span class="status-badge" [ngClass]="{
                    'status-not-started': subTask.status === 'NOT_STARTED',
                    'status-in-progress': subTask.status === 'IN_PROGRESS',
                    'status-completed': subTask.status === 'COMPLETED',
                    'status-on-hold': subTask.status === 'ON_HOLD'
                  }">
                    <i class="bx bx-pause-circle"
                      *ngIf="subTask.status === 'NOT_STARTED'"></i>
                    <i class="bx bx-time"
                      *ngIf="subTask.status === 'IN_PROGRESS'"></i>
                    <i class="bx bx-check-circle"
                      *ngIf="subTask.status === 'COMPLETED'"></i>
                    <i class="bx bx-stop-circle"
                      *ngIf="subTask.status === 'ON_HOLD'"></i>
                    {{ subTask.status || 'NOT_STARTED' }}
                  </span>
                  <i class="bx bx-chevron-down"></i>
                </div>
                <div class="dropdown-menu" *ngIf="subTask.showStatusDropdown">
                  <div class="dropdown-item"
                    (click)="selectStatus(subTask, 'NOT_STARTED')">
                    <span class="status-badge status-not-started">
                      <i class="bx bx-pause-circle"></i> NOT_STARTED
                    </span>
                  </div>
                  <div class="dropdown-item"
                    (click)="selectStatus(subTask, 'IN_PROGRESS')">
                    <span class="status-badge status-in-progress">
                      <i class="bx bx-time"></i> IN_PROGRESS
                    </span>
                  </div>
                  <div class="dropdown-item"
                    (click)="selectStatus(subTask, 'COMPLETED')">
                    <span class="status-badge status-completed">
                      <i class="bx bx-check-circle"></i> COMPLETED
                    </span>
                  </div>
                  <div class="dropdown-item"
                    (click)="selectStatus(subTask, 'ON_HOLD')">
                    <span class="status-badge status-on-hold">
                      <i class="bx bx-stop-circle"></i> ON_HOLD
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="assignee-column">
              <div class="assignee-dropdown">
                <div class="assignee-display"
                  (click)="toggleAssigneeDropdown(subTask)">
                  <div *ngIf="subTask.assignedToName" class="selected-assignee">
                    <div class="assignee-avatar">{{
                      subTask.assignedToName.charAt(0) }}</div>
                    {{ subTask.assignedToName }}
                  </div>
                  <div *ngIf="!subTask.assignedToName"
                    class="assignee-placeholder">Select Employee</div>
                  <i class="bx bx-chevron-down"></i>
                </div>
                <div class="dropdown-menu" *ngIf="subTask.showAssigneeDropdown">
                  <div class="dropdown-search">
                    <i class="bx bx-search"></i>
                    <input type="text" placeholder="Search users..."
                      (input)="filterUsers(subTask, $event)">
                  </div>
                  <div class="dropdown-list">
                    <div *ngFor="let user of users" class="dropdown-item"
                      (click)="selectAssignee(subTask, user)">
                      <div class="assignee-avatar">{{ user.avatar }}</div>
                      {{ user.name }}
                    </div>
                    <div *ngIf="users.length === 0" class="no-results">
                      No users found
                    </div>
                  </div>
                  <div class="dropdown-footer" (click)="clearAssignee(subTask)">
                    <i class="bx bx-x"></i> Clear
                  </div>
                </div>
              </div>
            </div>
            <div class="date-column">
              <input *ngIf="showDatePicker" type="date"
                [(ngModel)]="subTask.deadLine" class="date-input">
              <span *ngIf="!showDatePicker">{{ subTask.deadLine ?
                (subTask.deadLine | date:'MMMM d, yyyy') : ''
                }}</span>
            </div>
            <div class="priority-column">
              <div class="priority-dropdown">
                <div class="priority-display"
                  (click)="togglePriorityDropdown(subTask)">
                  <span class="priority-badge" [ngClass]="{
                    'priority-low': subTask.priority === 'LOW',
                    'priority-high': subTask.priority === 'HIGH'
                  }">
                    <i class="bx bx-flag"
                      *ngIf="subTask.priority === 'LOW'"></i>
                    <i class="bx bxs-flag-alt"
                      *ngIf="subTask.priority === 'HIGH'"></i>
                    {{ subTask.priority || 'LOW' }}
                  </span>
                  <i class="bx bx-chevron-down"></i>
                </div>
                <div class="dropdown-menu" *ngIf="subTask.showPriorityDropdown">
                  <div class="dropdown-item"
                    (click)="selectPriority(subTask, 'LOW')">
                    <span class="priority-badge priority-low">
                      <i class="bx bx-flag"></i> LOW
                    </span>
                  </div>
                  <div class="dropdown-item"
                    (click)="selectPriority(subTask, 'HIGH')">
                    <span class="priority-badge priority-high">
                      <i class="bx bxs-flag-alt"></i> HIGH
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container> -->
          <!-- <div class="new-sub-item sub-item" *ngIf="task.isExpanded"
          (click)="addNewTask()">
          <i class="bx bx-plus"></i> New sub-item
        </div> -->
        </ng-container>
      </form>
      <div class="new-page" (click)="addNewTask()"  [ngClass]="{ 'disabled-dropdown': privilege === 'VIEW' }">
        <i class="bx bx-plus"></i> New Task
      </div>
      <div *ngIf="isLoading" class="loading-spinner text-center">Loading more tasks...</div>
    </div>
  </div>
  <app-task-drawer *ngIf="showSidePopup" [showSidePopup]="showSidePopup" [isSubItem]="isSubItem" [newTask]="newTask"
    [employees]="employees" [projects]="projects" [milestones]="milestones" [parentTaskId]="parentTaskId"
    [editor]="editor" [toolbar]="toolbar" (taskUpdated)="onTaskUpdated($event)" (saveNewTask)="onSaveNewTask($event)"
    (closeSidePopup)="showSidePopup = false">
  </app-task-drawer>
</section>